import { render, staticRenderFns } from "./Purchasing.vue?vue&type=template&id=0c739c8c&scoped=true"
import script from "./Purchasing.vue?vue&type=script&lang=js"
export * from "./Purchasing.vue?vue&type=script&lang=js"
import style0 from "./Purchasing.vue?vue&type=style&index=0&id=0c739c8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c739c8c",
  null
  
)

export default component.exports